export const TAB_NAMES = ['basic', 'standard', 'premium', 'custom'];
export const customOrderPackage = { id: 4 };
